// extracted by mini-css-extract-plugin
export default {"container":"CharcodeTag_container__4rfqN","text":"CharcodeTag_text__qdA2h"};